<template lang="pug">
.form-user
  h3 {{editing ? '编辑' : '创建'}}用户
  el-form.ui.form(:model='form', ref='form')
    .two.fields
      el-form-item.ui.field.required(prop='username', :class='{error:form_errors.username}')
        label 用户名
        el-input(v-model='form.username', placeholder='用户名', :disabled='editing')
      el-form-item.ui.field.required(prop='display', :class='{error:form_errors.display}')
        label 显示名
        el-input(v-model='form.display', placeholder='显示名')

    .two.fields
      el-form-item.ui.field(prop='password', :class='{error:form_errors.password}')
        label {{editing ? '新' : ''}}密码
        el-input(v-model='form.password', type='password')
      el-form-item.ui.field(prop='password_repeat', :class='{error:form_errors.password_repeat}')
        label 重复密码
        el-input(v-model='password_repeat', type='password')

    .ui.field(:class='{error:form_errors.roles}')
      label 角色
      el-select(v-model='form.roles', multiple, placeholder='选择角色')
        el-option(v-for='role in roles', :key='role._id', :label='role.name', :value='role._id')

    .ui.field
      el-checkbox(v-model='form.enabled', label='启用')

    .ui.field.actions
      .ui.button.themed(@click='submit()') {{ editing ? '保存' : '创建'}}
      .ui.button(@click='cancel()') 取消
</template>

<script>
import { MakeForm } from '../../utils'

const username_regex = /^[a-zA-Z0-9_]+$/

export default {
  name: 'form-user',
  props: {
    user: null,
  },
  data() {
    return {
      editing: false,
      form: {
        _id: undefined,
        username: '',
        password: '',
        display: '',
        roles: [],
        enabled: true,
      },
      form_errors: {
        password: false,
        password_repeat: false,
        username: false,
        display: false,
        roles: false,
      },
      password_repeat: '',
    }
  },
  computed: {
    roles() {
      return this.$store.state.summary.roles
    },
  },
  mounted() {
    this.init()
  },
  watch: {
    user: {
      deep: true,
      handler() { this.init() },
    },
    form: {
      deep: true,
      handler() { this.clear_errors() },
    },
  },
  methods: {
    init() {
      if (this.user) {
        this.editing = true
        this.form._id = this.user._id
        this.form.username = this.user.username || undefined
        this.form.display = this.user.display || undefined
        this.form.password = undefined
        this.form.roles = this.user.roles || []
        this.form.enabled = this.user.enabled
      } else {
        this.editing = false
        this.form._id = undefined
        this.form.username = undefined
        this.form.display = undefined
        this.form.password = undefined
        this.form.roles = []
        this.form.enabled = true
      }
      this.password_repeat = undefined
      this.clear_errors()
    },
    vaildate() {
      if (!this.form.username || !this.form.username.trim()) {
        this.form_errors.username = true
        return false
      } else if (!this.editing) {
        if (!username_regex.test(this.form.username)) {
          this.form_errors.username = true
          return false
        }
      }

      if (!this.form.display || !this.form.display.trim()) {
        this.form_errors.display = true
        return false
      }

      if (!this.form.roles || !this.form.roles.length) {
        this.form_errors.roles = true
        return false
      }

      if (this.form.password && this.form.password.trim()) {
        if (this.form.password.length < 6) {
          this.form_errors.password = true
          return false
        }
        if (this.form.password !== this.password_repeat) {
          this.form_errors.password_repeat = true
          return false
        }
      }
      return true
    },
    clear_errors() {
      this.form_errors = {
        password: false,
        password_repeat: false,
        username: false,
        display: false,
        roles: false,
      }
    },
    submit_form_edit: MakeForm({
      type: 'put',
      url() { return `users/${this.form._id}` },
      confirm: '确定修改用户？',
      payload() { return this.form },
      $afterSuccess() {
        this.exit()
      },
    }),
    submit_form_create: MakeForm({
      type: 'post',
      url: 'users',
      confirm: '确定创建该用户？',
      payload() { return this.form },
      $afterSuccess() {
        this.exit()
      },
    }),
    submit() {
      if (this.vaildate()) {
        if (this.editing)
          this.submit_form_edit()
        else
          this.submit_form_create()
      }
    },
    cancel() {
      this.exit()
    },
    exit() {
      this.$emit('exit')
      this.init()
    },
  },
}
</script>



// WEBPACK FOOTER //
// FormUser.vue?1087a0fd